import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
// import Manufacturer from "../Manufacturer/Manufacturer";
import TitleBar from "../../common/title-bar/title-bar";
import Button from "../../common/button/button";
import Table from "../../common/table";
import Text from "../../common/typography/text";
import TableOptionsCell from "../../common/table/table-options-cell";

export const dummyDistributorCommissionStatements = [
  {
    CommissionID: 1,
    DistributorID: 10,
    DistributorName: "MPKM Innovative Solutions",
    CommissionMonth: "May 2025",
    Invoice: 1234,
    InvoiceDate: "May 22nd, 2025",
    Account: "Account Name",
    Manufacturer: "Manufacturer",
    Products: 12,
    StatementDate: "05-23-2025",
    TotalCommApplied: "$200,000",
    TotalCommRecieved: "$200,000",
    TotalCommDue: "$100,000",
  },
  {
    CommissionID: 2,
    DistributorID: 20,
    DistributorName: "MPKM Innovative Solutions",
    CommissionMonth: "April 2025",
    Invoice: 1234,
    Products: 10,
    Manufacturer: "Manufacturer",
    InvoiceDate: "May 22nd, 2025",
    Account: "Account Name",
    StatementDate: "04-23-2025",
    TotalCommApplied: "$150,000",
    TotalCommRecieved: "$200,000",
    TotalCommDue: "$150,000",
  },
  {
    CommissionID: 3,
    DistributorID: 30,
    DistributorName: "MPKM Innovative Solutions",
    CommissionMonth: "March 2025",
    Manufacturer: "Manufacturer",
    InvoiceDate: "May 22nd, 2025",
    Account: "Account Name",
    Products: 15,
    Invoice: 1234,
    StatementDate: "03-23-2025",
    TotalCommApplied: "$100,000",
    TotalCommRecieved: "$200,000",
    TotalCommDue: "$100,000",
  },
  {
    CommissionID: 4,
    DistributorID: 40,
    DistributorName: "MPKM Innovative Solutions",
    CommissionMonth: "February 2025",
    Products: 13,
    Invoice: 1234,
    Manufacturer: "Manufacturer",
    InvoiceDate: "May 22nd, 2025",
    Account: "Account Name",
    StatementDate: "02-23-2025",
    TotalCommApplied: "$200,000",
    TotalCommRecieved: "$200,000",
    TotalCommDue: "$70,000",
  },
];

const DistributorCommissionStatements = () => {
  const { id } = useParams();
  const [comm, setComm] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const defaultSegment =
    queryParams.get("tab") === "details"
      ? "Distributor Commission Statements Details"
      : "Distributor Commission Statements Home";

  const [selectedSegment, setSelectedSegment] = useState(defaultSegment);

  const handleSegmentChange = (value) => {
    setSelectedSegment(value);
  };

  useEffect(() => {
    dummyDistributorCommissionStatements.find((el) => {
      if (el.CommissionID === Number(id)) {
        setComm(el);
      }
    });
  }, [id]);

  const tableHeadersDistributorCommissionsStatements = [
    {
      headerName: "Invoice",
      field: "Invoice",
      filter: true,
    },
    {
      headerName: "Account",
      field: "Account",
      filter: true,
    },
    {
      headerName: "Manufacturer",
      field: "Manufacturer",
      filter: true,
    },
    {
      headerName: "Invoice Date",
      field: "InvoiceDate",
      filter: true,
    },
    {
      headerName: "Products",
      field: "Products",
      filter: true,
    },
    {
      headerName: "Comm. Applied",
      field: "TotalCommApplied",
      filter: true,
    },
    {
      headerName: "Comm. Due",
      field: "TotalCommDue",
      filter: true,
    },
    {
      headerName: "Options",
      field: "",
      sortable: false,
      cellRenderer: (params) => (
        <TableOptionsCell
          optionOne="View"
          optionOneType="warning"
          //   optionOneClickPath={`/DistributorCommissionStatements/${params.data.ID}`}
          rowData={params.data}
        />
      ),
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      <TitleBar
        entityName="Distributor"
        label={comm.DistributorName}
        filterBarComponents={
          <>
            <Button
              isActive={
                selectedSegment === "Distributor Commission Statements Home"
              }
              variant="timeframe"
              onClick={() =>
                handleSegmentChange("Distributor Commission Statements Home")
              }
            >
              Home
            </Button>
            <Button
              isActive={
                selectedSegment === "Distributor Commission Statements Details"
              }
              variant="timeframe"
              onClick={() =>
                handleSegmentChange("Distributor Commission Statements Details")
              }
            >
              Details
            </Button>
            <Button
              isActive={selectedSegment === "Commissions"}
              variant="timeframe"
              onClick={() => handleSegmentChange("Commissions")}
            >
              Commissions
            </Button>
          </>
        }
      />
      <Text variant="bodyText">
        Commission Statement {comm.CommissionMonth}{" "}
      </Text>
      {selectedSegment === "Distributor Commission Statements Home" && (
        <Table
          rowData={dummyDistributorCommissionStatements}
          columnDefs={tableHeadersDistributorCommissionsStatements}
        />
      )}
    </div>
  );
};

export default DistributorCommissionStatements;
